import { Directive, DOCUMENT, ElementRef, inject, input } from '@angular/core';

@Directive({
  selector: '[flyTo]',
  standalone: false,
  host: {
    '(click)': 'fly()'
  }
})
export class FlyTo {
  readonly flyTo=input.required<string>(); //correspond à l'id de la cible 
  private readonly doc=inject(DOCUMENT);
  private readonly host=inject(ElementRef<HTMLElement>);

  constructor() { }

  fly(){
    const source=this.host.nativeElement;
    const target=document.getElementById(this.flyTo());

    if(source && target){
      const src=source.getBoundingClientRect();
      const dst=target.getBoundingClientRect();

      const ghost=source.cloneNode(true) as HTMLElement;

      Object.assign(ghost.style, {
        position: 'fixed',
        left: `${src.left}px`,
        top: `${src.top}px`,
        width: `${src.width}px`,
        height: `${src.height}px`,
        margin: '0',
        zIndex: '9999',
        pointerEvents: 'none',
        transformOrigin: 'top left',
      });

      this.doc.body.appendChild(ghost);

      const dx=dst.left-src.left;
      const dy=dst.top-src.top;
      const sx=dst.width/src.width;
      const sy=dst.height/src.height;

      const anim=ghost.animate(
        [
          { transform: 'translate(0,0) scale(1,1)', opacity: 1 },
          { transform: `translate(${dx}px, ${dy}px) scale(${sx}, ${sy})`, opacity: 0.15 },
        ],
        { duration: 420, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' }
      );

      anim.onfinish=() => ghost.remove();
    }
  }
}
